import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { IAppSummary } from '~/types/application'
import type { DeviceType } from '~/types/device-type'
import type { ITranslationKeyValue } from '~/types/translation'

import { getTranslationValues } from '~/api/translation'

export const keys = {
  all: ['translation'] as const,
  values: ({
    deviceType,
    lokaliseId,
    translationKeys,
  }: {
    deviceType: string
    lokaliseId: string
    translationKeys: string[]
  }) => [...keys.all, lokaliseId, deviceType, translationKeys] as const,
}

////////// QUERIES //////////
export const useTranslationValuesQuery = ({
  application,
  translationKeys,
}: {
  application: IAppSummary
  translationKeys: string[]
}): UseQueryResult<ITranslationKeyValue[]> => {
  return useQuery({
    enabled: !!translationKeys.length,

    queryFn: () =>
      getTranslationValues({
        deviceType: application?.device_type as DeviceType,
        lokaliseId: application?.lokalise_id as string,
        translationKeys: translationKeys as string[],
      }),
    queryKey: keys.values({
      deviceType: application?.device_type as string,
      lokaliseId: application?.lokalise_id as string,
      translationKeys: translationKeys as string[],
    }),
  })
}
